import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik"
import * as Yup from "yup"
import * as XLSX from "xlsx";
import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
  ModalHeader,
  Input,
  FormFeedback,
  Form,
  Modal,
} from "reactstrap";
import { getDeleteEntity, getEntityDetails } from "http/fundLync/entityAndAddress.helper";

import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getEntity, updateEntityStatus } from "../../http/fundLync/entityAndAddress.helper";
import { decryptedValue, isPermission, uId } from "common/utility";
import TableContainerV1 from "components/Common/TableContainerV1";
import { isEmpty, set } from "lodash";
import ToastDialog from "components/Common/ToastDialog";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { formatDateString } from "pages/EntityDashboard/borrowingProfile";
import { getlistingPreference } from "http/fundLync/listingPreferenceHelper";
import { HTML5Backend } from "react-dnd-html5-backend";
// import { TouchBackend } from 'react-dnd-touch-backend';
import { DndProvider } from "react-dnd";
import ColumnDragDrop from "hooks/columnDragDrop";
import { isMobile } from "react-device-detect";
import { TouchBackend } from "react-dnd-touch-backend";
import DeleteModal from "components/Common/DeleteModal";


const TableActionsComponent = (props, entityType,setEntityList,setPagination) => {
  const navigate = useNavigate();
  const user = decryptedValue(localStorage.getItem("user"));
  const [isDeletePermission, setIsDeletePermission] = useState(false);
  const [toastInfo, setToastInfo] = useState({
    showToast: false,
    message: "",
    role: "",
  });
  const [showCommonDialog, setShowCommonDialog] = useState({isShow:false});
  const navigateToEditRoles = (id, entityType) => {
    const encryptedId = btoa(id.toString());
    if (entityType == "Customer") {
      navigate(
        `/${user.roleName}/entity-Dashboard?id=${encodeURIComponent(
          encryptedId
        )}`
      );
    } else {
      navigate(
        `/${user.roleName}/financierDetails?id=${encodeURIComponent(
          encryptedId
        )}`
      );
    }
  };

  const navigateToDetails = (rowData) => {
    const encryptedId = btoa(rowData.id.toString());
    let url;
    if (!isEmpty(entityType) && entityType == "Financier") {
      url = `/financier/entity/information?id=${encodeURIComponent(encryptedId)}&entityName=${rowData.entityName}`;
    } else {
      url = `/${user.roleName}/entity/information?id=${encodeURIComponent(
        encryptedId
      )}&entityName=${rowData.entityName}`;
    }
    navigate(url);
  };

  const navigateToAddNotes = (id, entityName) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${user.roleName}/entity/add-notes?id=${encodeURIComponent(encryptedId)}&entityName=${entityName || ""}`);
  };

  // Navigate to add task page
  const navigateToAddTask = (id,entityName) => {
    const encryptedId = btoa(id.toString());
    let url = `/${user.roleName}/add-task?id=${encodeURIComponent(encryptedId)}&entityName=${entityName || ""}`;
    navigate(url);
  };

  // Navigate to Schedule Meeting Page
  const navigateToScheduleMeeting = (id,entityName) => {
    const encryptedId = btoa(id.toString());
    let url = `/${user.roleName}/schedule-meeting?id=${encodeURIComponent(encryptedId)}&entityName=${entityName || ""}`;
    navigate(url);
  };

  const showPortofolio = (rowData) => {
    // return rowData.entityType == "Customer";
    return false
  };

  const navigateToDealPage = (rowData) => {
    const encryptedId = btoa(rowData?.id?.toString());
    const nonFinancierType = btoa(rowData?.nonFinancierType?.toString());
    const entityName = btoa(rowData?.entityName?.toString());
    let url = `/${user.roleName}/addDeal?id=${encodeURIComponent(encryptedId)}&nonFinancierType=${encodeURIComponent(nonFinancierType)}&entityName=${encodeURIComponent(entityName)}`;
    navigate(url);
  };

  useEffect(() => {
    const checkDeletePermission = async () => {
      const permission = await isPermission("entity_detail", "delete_permission");
      setIsDeletePermission(permission);
    };
    checkDeletePermission();
  }, []);
  const deleteEntity = async (entityId) => {
    try {
      const response = await getDeleteEntity({ id: entityId });

      if (response.code === 201 && response.status === true) {
        setEntityList((prevList) => prevList.filter((entity) => entity.id !== entityId));
        setPagination(prevPagination => ({
          ...prevPagination,
          totalRecords: prevPagination.totalRecords - 1
        }));
        setToastInfo({
          message: response.message,
          showToast: true,
          role: "success",
        });
      } else {
        setToastInfo({
          message: response.message || "Failed to fetch data",
          showToast: true,
          role: "error",
        });
      }
    } catch (error) {
      setToastInfo({
        message: error.message || "Something went wrong",
        showToast: true,
        role: "error",
      });
    } finally {
      setShowCommonDialog({ isShow: false });
    }
  }

  const openCommonDialog = (message, entityId) => {
    setShowCommonDialog({ isShow: true, message });
  };
  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            navigateToEditRoles(props.id, props.entityType);
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="edittooltip"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="edittooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>
        {showPortofolio(props) && (
          <DropdownItem
            onClick={() => {
              navigateToDetails(props);
            }}
          >
            <i
              className="mdi mdi-eye font-size-16 text-success me-1"
              id="viewTooltip"
            ></i>
            View
            <UncontrolledTooltip placement="top" target="viewTooltip">
              View
            </UncontrolledTooltip>
          </DropdownItem>
        )}
        <DropdownItem onClick={() => navigateToAddNotes(props.id, props.entityName)}>
          <i
            className="mdi mdi-note-plus font-size-16 text-success me-1"
            id="addNotesTooltip"
          ></i>
          Add Notes
          <UncontrolledTooltip placement="top" target="addNotesTooltip">
            Add Notes
          </UncontrolledTooltip>
        </DropdownItem>


        <DropdownItem onClick={() => navigateToAddTask(props.id,props.entityName)}>
          <i className="mdi mdi-plus-box font-size-16 text-success me-1" id="addTaskTooltip"></i>
          Add Task
          <UncontrolledTooltip placement="top" target="addTaskTooltip">Add Task</UncontrolledTooltip>
        </DropdownItem>

        {/* Add Meetings */}
        <DropdownItem onClick={() => navigateToScheduleMeeting(props.id,props.entityName)}>
          <i className="mdi mdi-calendar font-size-16 text-success me-1" id="addTaskTooltip"></i>
          Schedule Meeting
          <UncontrolledTooltip placement="top" target="addTaskTooltip">Schedule Meeting</UncontrolledTooltip>
        </DropdownItem>
        {props.pan && props.pan !== "" && (
        <DropdownItem
          onClick={() => {
            navigateToDealPage(props);
          }}
        >
          <i
            className="mdi mdi-plus font-size-16 text-success me-1"
            id="edittooltip"
          ></i>
          Create Deal
          <UncontrolledTooltip placement="top" target="edittooltip">
            Create Deal
          </UncontrolledTooltip>
        </DropdownItem>
        )}
        {isDeletePermission && !props.hasDealPresent &&(
        <DropdownItem
        onClick={() => openCommonDialog("Are you sure you want to delete this Entity?",props.id)}>
          <i
            className="mdi mdi-delete font-size-16 text-success me-1"
            id="deletetooltip"
          ></i>
           Delete 
          <UncontrolledTooltip placement="top" target="deletetooltip">
          Delete
          </UncontrolledTooltip>
        </DropdownItem>)}
        </DropdownMenu>
      <DeleteModal
        msg={showCommonDialog.message}
        show={showCommonDialog.isShow}
        onDeleteClick={() => deleteEntity(props.id)}
        onCloseClick={() => setShowCommonDialog({ isShow: false })}
      />

      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />

    </UncontrolledDropdown>
  )
}

const Entities = (props) => {
  document.title = "List Entity | Fundlync";

  const navigate = useNavigate();
  const [entityList, setEntityList] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [isNewEntityPermission, setIsNewEntityPermission] = useState(false);
  const [isDownloadPermission, setIsDownloadPermission] = useState(false)
  // const userData = localStorage.getItem("user") || "{}";
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [isSelectFieldPermission, setIsSelectFieldPermission] = useState(false)
  const userObj = decryptedValue(localStorage.getItem("user")) || {};
  const { entityType } = userObj || "";
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action", "Request Consent"],
  });
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const urlParams = new URLSearchParams(window.location.search);
  const filterType = urlParams.get("filter");
  let decodeFilterType = atob(urlParams.get("filter"));
  const [entityStatusBucketList, setEntityStatusBucketList] = useState([]);


  const [filterValue, setFilterValue] = useState([]);

  const handleMouseEnter = (event) => {
    event.target.style.color = "#34c38f";
    event.target.style.textDecoration = 'underline';
  };

  const handleMouseLeave = (event) => {
    event.target.style.color = "#21aa47";
    event.target.style.textDecoration = 'none';
  };

  const handleStatusChange = (data) => {
    validation.setFieldValue('id', data.id)
    getDropDownList({ dropdownName: "Entity Status Buckets" })
      .then((response) => {
        if (response.status) {
          const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Entity Status Buckets")?.dropdownValues || []
          const modifiedDropdownValues = dropdownValues.map(dv => ({
            label: dv.displayName,
            value: dv.dropdownValue
          }));
          setEntityStatusBucketList(modifiedDropdownValues)
          setIsStatusModal(true)
        }
      }).catch((error) => {
        console.log(error);
      })
  };

  const navigateToEditEntity = async (data) => {
    try {
      const entityId = data.id;
      try {
        const entityDetailsResponse = await getEntityDetails({ entityId });
        const entityType = entityDetailsResponse.data.entity_type;
        const encryptedId = btoa(entityId.toString());
        if (entityType === 'Customer') {
          navigate(`/${user.roleName}/entity-Dashboard?id=${encodeURIComponent(encryptedId)}`);
        } else {
          navigate(`/${user.roleName}/financierDetails?id=${encodeURIComponent(encryptedId)}`);
        }
      } catch (entityError) {
        console.error('Error fetching entity details:', entityError);
      }
    } catch (dealError) {
      console.log('Error fetching entity details:', dealError)
    }
  };
  const truncateText = (text, charLimit) => {
    if (text && text.length > charLimit) {
      const truncated = text.substring(0, charLimit) + "...";
      return truncated;
    }
    return text;
  };
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        hideOrder:7,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Entity Name",
        accessor: "entityName",
        filterable: true,
        hideOrder:0,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original
          return (
            <span onClick={()=>{navigateToEditEntity(rowData)}}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ cursor: 'pointer', color: '#21aa47',width: "170px", }}
            >
              {truncateText(rowData?.entityName, 20) || ""}
            </span>
          );
        },
      },
      {
        Header: "PAN",
        accessor: "pan",
        filterable: true,
        hideOrder:7,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      // {
      //   Header: "GSTN",
      //   accessor: "gstnIn",
      //   filterable: true,
      //   Cell: (cellProps) => {
      //     return cellProps.value || "";
      //   },
      // },
      {
        Header: "Entity Type",
        accessor: "entityType",
        filterable: true,
        hideOrder:3,
        Cell: (cellProps) => {
          return `${cellProps.value || ""}`;
        },
      },
      {
        Header: "RM",
        hideOrder:4,
        accessor:"RM",
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          const firstName = rowData.programOwnerUser ?.first_name || "";
          const lastName = rowData.programOwnerUser ?.last_name || "";
          return `${firstName} ${lastName}`.trim() || "";
        },
      },
      {
        Header: "Constitution",
        accessor: "entityConstitution",
        filterable: true,
        hideOrder:5,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Created On",
        accessor: "createdAt",
        filterable: true,
        hideOrder:6,
        Cell: (cellProps) => {
          return formatDateString(cellProps.value) || "";
        },
      },
      {
        Header: "Status",
        accessor: "entityStatus",
        filterable: true,
        hideOrder:1,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original
          return (
            <span onClick={()=>{handleStatusChange(rowData)}}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ cursor: 'pointer', color: '#21aa47' }}
            >
              {rowData?.entityStatus || ''}
            </span>
          );
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent({ ...rowData, deals: rowData.deals }, entityType,setEntityList,setPagination);
        },
      },
    ],
    []
  );

  const validation = useFormik({
    initialValues: {
      id: "",
      entityStatus: "",
    },
    validationSchema: Yup.object({
      entityStatus: Yup.string().required("Please select Entity Status"),
    }),
    onSubmit: (values) => {
      const data = {
        id: values.id,
        entityStatus: values.entityStatus,
      }
      updateEntityStatus(data).then((response)=>{
        if(response && response.status){
          setToastInfo({
            message: response.message,
            showToast: true,
            role: "success",
          })
        handlePageChange(pagination.pageIndex || 1, pageSize, searchValue, columnId, sortingOrderStatus, filterValue);
        }else{
          setToastInfo({
            message: response.message || 'Something went wrong!',
            showToast: true,
            role: "error",
          })
        }
        validation.resetForm()
        setIsStatusModal(false)
      }).catch((error)=>{
        setIsStatusModal(false)
        setToastInfo({
          message: 'Something went wrong!',
          showToast: true,
          role: "error",
        })
      })
    },
  });

  const getEntities = (data) => {
    getEntity(data)
      .then((responseFromAPI) => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setEntityList(responseFromAPI.data.data);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data;
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          });
        } else {
          setEntityList([]);
          setPagination({
            pageIndex: 0,
            pageCount: 0,
            totalRecords: 0,
          });
        }
      })
      .catch((error) => { });
  };
  const user = decryptedValue(localStorage.getItem("user"));
  const handlePageChange = (
    page,
    pageSize,
    searchKey = searchValue,
    columnName = columnId,
    sortingOrder = sortingOrderStatus,
    filter = filterValue
  ) => {
    // setPageSize(pageSize);
    const data = JSON.parse(localStorage.getItem("selectedFilters_entity_tab_1"))
    // if(data?.length > 0){
    //   getEntities({
    //     page,
    //     limit: pageSize,
    //     searchKey,
    //     columnName,
    //     sortingOrder,
    //     user, filter:data
    //    })
    // }
    if (filterType) {
      getEntities({
        page,
        limit: pageSize,
        searchKey,
        columnName,
        sortingOrder,
        filterType: decodeFilterType,
        user,
        filter
      });
    } else {
      getEntities({
        page,
        limit: pageSize,
        searchKey,
        columnName,
        sortingOrder,
        user,
        filter
      });
    }
  };

  // Sort
  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder, filterValue);
  };

  useEffect(() => {
    handlePageChange(1, pageSize, searchValue, columnId, sortingOrderStatus, filterValue);
  }, [filterValue, pageSize]);

  let debounceTimeout;
  const handleSearchFilter = (value, pageSize) => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      if (filterType) {
        if (value) {
          setSearchValue(value);
          handlePageChange(1, pageSize, value, columnId, sortingOrderStatus, filterValue);
        } else {
          setSearchValue(decodeFilterType);
          handlePageChange(1, pageSize, decodeFilterType, columnId, sortingOrderStatus, filterValue);
        }
      } else {
        setSearchValue(value);
        handlePageChange(1, pageSize, value, columnId, sortingOrderStatus, filterValue);
      }
    }, 500);
  };

  // Filter
  const handleFilter = (newFilterValue, newPageSize) => {
    setSearchValue("")
    setFilterValue(newFilterValue);
    setPageSize(newPageSize);
    handlePageChange(1, newPageSize, "", columnId, sortingOrderStatus, newFilterValue);
  };

  // Clear
  const handleClearSearch = () => {
    if (filterType) {
      setSearchValue(decodeFilterType);
      setFilterValue([])
      handlePageChange(1, pageSize, decodeFilterType, columnId, sortingOrderStatus, []);
    } else {
      setSearchValue("");
      setFilterValue([])
      handlePageChange(1, pageSize, "", columnId, sortingOrderStatus, []);
    }
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("selectedFilters_entity_tab_1"))
    setFilterValue(data || [])
    if(data?.length > 0){
      getEntities({ user, filter:data })
    }
    else if (filterType) {
      getEntities({ searchKey: `${decodeFilterType}`, user });
    } else {
      getEntities({ user });
    }
    checkPermissions();
    getlistingPreference({ userId: user.id, tableType: "entity" })
      .then((response) => {
        if (response.code == 200 && response.status) {
          const apiColumns = response.data?.columnData || [];
          const mappedColumns = apiColumns.map((apiColumn) => {
            const matchedColumn = columns.find(col => col.accessor === apiColumn.accessor);
            if (matchedColumn) {
              return {
                ...matchedColumn,
                ...apiColumn,
              };
            }
            return apiColumn;
          });
          setSelectedColumns(mappedColumns);
        } else {
          setSelectedColumns([])
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const checkPermissions = async () => {
    const isNewEntitypermission = await isPermission(
      "entity_detail",
      "create_permission"
    );
    setIsNewEntityPermission(isNewEntitypermission);
    const isSelectedFieldpermission = await isPermission(
      "select-listing-preference", 
      "create_permission"
    );
    setIsSelectFieldPermission(isSelectedFieldpermission)
    const isSDownloadpermission = await isPermission(
      "download_excel_data", 
      "view_permission"
    );
    setIsDownloadPermission(isSDownloadpermission)
  };

  const handleCustomerClicks = () => {
    navigate(`/${user.roleName}/addEntity`);
  };
  const toggleModal = () => setIsModalOpen(!isModalOpen)

  const createAndDownloadExcel = async (fileName, entities) => {
    if (entities.length === 0) {
      setToastInfo({
        message: "No entities available for download.",
        showToast: true,
        role: "warning",
      });
      return;
    }
  
    let newData = entities.map((ele) => {
      const contact = ele?.pointOfContacts?.[0];
      const address = ele?.addresses?.[0];
      return {
        // Id: ele.id || "",
        "Entity Name": ele.entityName || "",
        "PAN": ele.pan || "",
        "Entity Type": ele.entityType || "",
        "RM": `${ele.programOwnerUser?.first_name || ""} ${
          ele.programOwnerUser?.last_name || ""
        }`.trim(),
        "Constitution": ele.entityConstitution || "",
        "Region": ele.region || "",
        "Contact Name": contact
          ? `${contact.firstname || ""} ${contact.lastname || ""}`.trim()
          : "",
        "Email": contact ? contact.email || "" : "",
        "Contact number": contact ? contact.contact_number || "" : "",
        "Designation": contact ? contact.designation || "" : "",
        "Address": address
          ? `${address.address1 || ""} ${address.address2 || ""} ${address.address3 || ""}`.trim()
          : "",
        "State": address ? address.state || "" : "",
        "City": address ? address.city || "" : "",
        "Pincode": address ? address.pincode || "" : "",
        "Created On": ele.createdAt ? formatDateString(ele.createdAt) : "",
        "Status": ele.entityStatus || "",
      };
    });
    
  
    const ws = XLSX.utils.json_to_sheet(newData);    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Entities");
    const buffer = XLSX.write(wb, {
      bookType: "xlsx",
      bookSST: false,
      type: "array",
    });
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.download = `${fileName}.xlsx`;
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadData = () => {
  const fileName = "Entities";
  const filters = filterValue.length > 0 ? filterValue : [];
  const sortingOrder = sortingOptions.isAsc ? "asc" : "desc";
  const columnName = sortingOptions.column;
  const limit = pageSize || 10000;
  getEntity({
    page: 1,          
    limit,             
    searchKey: searchValue || "", 
    columnName,       
    sortingOrder,   
    filter: filters,   
    user              
  })
  .then((response) => {
    if (response.data && response.data.data) {
      const entities = response.data.data;
      createAndDownloadExcel(fileName, entities);
      setToastInfo({
        message: "File downloaded successfully!",
        showToast: true,
        role: "success",
      });
    } else {
      setToastInfo({
        message: "No entities available for download.",
        showToast: true,
        role: "warning",
      });
    }
  })
  .catch((error) => {
    setToastInfo({
      message: "Error fetching entities for download.",
      showToast: true,
      role: "error",
    });
  });
};

  const buttonSection = (
    <div className="d-flex justify-content-end">
      <div>
        {isSelectFieldPermission && (
          <>
            <div className="d-flex justify-content-end">
              <Button
                type="button"
                color="light"
                className="btn-rounded mb-2 me-2 ms-2 border-success"
                onClick={toggleModal}
              >
                <i className="mdi mdi-table-column-plus-before me-2" />
                {"Select Fields"}
              </Button>
            </div>

            {isModalOpen && (
              <div
                className="filter-popup display-flex justify-content-end vertical-scroll"
                style={{
                  position: "absolute",
                  top: "2.4rem",
                  right: "0",
                  background: "white",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                  zIndex: 2000,
                  padding: "10px",
                  borderRadius: "5px",
                  minHeight: "350px",
                  maxHeight: "400px",
                  overflow: "auto",
                  maxWidth: "600px",
                  width: "100%",
                }}
              >
                <div className="mb-1 d-flex justify-content-between align-items-center text-center">
                  <h6 style={{ margin: 0 }}>
                    Drag and drop columns from Available to Selected for your
                    preference
                  </h6>
                  <button
                    type="button"
                    onClick={toggleModal} // Close the dropdown
                    style={{
                      border: "none",
                      background: "transparent",
                      fontSize: "1.2rem",
                      cursor: "pointer",
                    }}
                  >
                    ×
                  </button>
                </div>
                <DndProvider  backend={isMobile ? TouchBackend : HTML5Backend} options={{ enableMouseEvents: true }}>
                  <ColumnDragDrop
                    columns={columns}
                    onApply={setSelectedColumns}
                    toggleModal={toggleModal}
                    tableType="entity"
                  />
                </DndProvider>
              </div>
            )}
          </>
        )}
      </div>
      <div>
      {isDownloadPermission && (
        <>
        <Button
        id="downloadTooltip"
        type="button"
        color="light"
        className="btn-rounded mb-2 me-2 ms-2 border-success"
        onClick={() => {
          handleDownloadData();
        }}
      >
        <i className="fa fa-download" ></i>
      </Button>
      <UncontrolledTooltip placement="top" target="downloadTooltip">
        Download Entity Data
      </UncontrolledTooltip></>
      )} 
      </div>
      
      
    </div>
  );

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-1">
      <Breadcrumbs title="Entity List" />

      {isNewEntityPermission && (
        <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-2"
          onClick={handleCustomerClicks}
        >
          <i className="mdi mdi-plus me-1" />
          {"New Entity"}
        </Button>
      )}
    </div>
      <Row className="vertical-scroll">
        <Col xs="12">
          <Card>
            <CardBody>
              <TableContainerV1
                tabIndex={1}
                columns={selectedColumns.length > 0 ? selectedColumns : columns}
                data={entityList}
                pagination={pagination}
                handlePageChange={handlePageChange}
                handleSearchFilter={handleSearchFilter}
                customSection={buttonSection}
                sortOptions={sortingOptions}
                handleSortColumn={handleSortColumn}
                handleClearSearch={handleClearSearch}
                className="custom-header-css"
                tableFor="entity"
                handleFilter={handleFilter}
                activeTab={1}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>

      <Modal
        isOpen={isStatusModal}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setIsStatusModal(!isStatusModal);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setIsStatusModal(!isStatusModal);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Select Entity Status</h4>
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Col xl={12} >
                    <Input
                      name="entityStatus"
                      type="select"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.entityStatus}
                      invalid={validation.touched.entityStatus && !!validation.errors.entityStatus}
                    >
                      <option value="" selected disabled>Select Entity Status</option>
                      {entityStatusBucketList?.map((option) => (
                        <option key={uId()} value={option.value}>
                          {option.label}
                        </option>
                      ))}

                    </Input>
                    {validation.touched.entityStatus && validation.errors.entityStatus ? (
                      <FormFeedback type="invalid">
                        {validation.errors.entityStatus}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Row>
                    <Col sm="12" >
                      <div className="d-flex gap-3 justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success save-customer mt-2"
                        >
                          Submit
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Entities;

